import React from 'react'

interface ModalLogoutProps {
    onClose: () => void;
    onConfirm: () => void;
}

const ModalLogout: React.FC<ModalLogoutProps> = ({ onClose, onConfirm }) => {
  return (
    <div className="fixed h-screen inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
      <div className="bg-white rounded-xl shadow-2xl p-6 w-[90%] max-w-md transform transition-all animate-slideUp">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </div>
        </div>
        
        <h2 className="text-xl font-bold mb-2 text-center text-zinc-800">Confirm Logout</h2>
        <p className="text-gray-600 mb-6 text-center">Are you sure you want to log out of your account?</p>
        
        <div className="flex gap-3">
          {/* Cancel Button */}
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 font-semibold transition-all duration-200 shadow-sm hover:shadow-md"
          >
            Cancel
          </button>
          {/* Confirm Button */}
          <button
            onClick={onConfirm}
            className="flex-1 px-4 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-sm hover:shadow-md"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalLogout